// postAssessmentStep.js
import { API_HOST_V1 } from '../constants/constants';
import useCurrentUser from '../hooks/useCurrentUser';
import axios from 'axios';

/**
 * @param {Object} payload - The request body
 * @param {'restart' | 'backwards'} [mode] - Optional mode: 'restart', 'backwards', or undefined for default
 */
export const postAssessmentStep = async (payload, mode) => {
  const { token, userID, partnerID } = useCurrentUser();

  let url = `${API_HOST_V1}/workflows/existing_workflow_next_step`;
  if (mode === 'restart') {
    url = `${API_HOST_V1}/workflows/next_step`;
  } else if (mode === 'backwards') {
    url = `${API_HOST_V1}/workflows/previous_step`;
  }

  try {
    const { data } = await axios.post(url, payload, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
        'x-dqpn-partner-id': partnerID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
